import { useDispatch } from "react-redux";
import { change_Lang } from "../../actions/Helper_action";

export const FilterComponent = ({
  main_state,
  secondary_state,
  element,
  change_able,
}) => {
  if (isNaN(main_state)) {
    if (change_able) {
      return true;
    } else if (
      element.firstname &&
      element.firstname.toLowerCase().startsWith(main_state.toLowerCase())
    ) {
      return true;
    } else if (
      element.available_id &&
      element.available_id.block &&
      element.available_id.block
        .toLowerCase()
        .startsWith(main_state.toLowerCase())
    ) {
      return true;
    } else if (
      element.available_id &&
      element.available_id.NOoFProperty.toString().startsWith(main_state)
    ) {
      return true;
    }
  } else if (secondary_state === "Apartment") {
    return (
      element.available_id && element.available_id.Property === "Apartment"
    );
  } else if (secondary_state === "House") {
    return element.available_id && element.available_id.Property === "House";
  } else if (secondary_state === "Farm") {
    return element.available_id && element.available_id.Property === "Farm";
  } else if (secondary_state === "Shop") {
    return element.available_id && element.available_id.Property === "Shop";
  } else if (secondary_state === "Vella") {
    return element.available_id && element.available_id.Property === "Vella";
  } else if (secondary_state === "Earth") {
    return element.available_id && element.available_id.Property === "Earth";
  } else if (secondary_state === "Strecture") {
    return (
      element.available_id && element.available_id.Property === "Strecture"
    );
  } else if (secondary_state === "The gas station") {
    return (
      element.available_id &&
      element.available_id.Property === "The gas station"
    );
  } else if (secondary_state === "Factory") {
    return element.available_id && element.available_id.Property === "Factory";
  } else if (secondary_state === "GYM") {
    return element.available_id && element.available_id.Property === "GYM";
  } else if (secondary_state === "store") {
    return element.available_id && element.available_id.Property === "store";
  } else if (secondary_state === "Restaurant") {
    return (
      element.available_id && element.available_id.Property === "Restaurant"
    );
  } else if (secondary_state === "Commercial Land") {
    return (
      element.available_id &&
      element.available_id.Property === "Commercial Land"
    );
  } else if (secondary_state === "Company") {
    return element.available_id && element.available_id.Property === "Company";
  } else if (secondary_state === "Hotel") {
    return element.available_id && element.available_id.Property === "Hotel";
  } else if (secondary_state === "Car Garage") {
    return (
      element.available_id && element.available_id.Property === "Car Garage"
    );
  } else if (secondary_state === "Stadium") {
    return element.available_id && element.available_id.Property === "Stadium";
  } else if (secondary_state === "Car wash") {
    return element.available_id && element.available_id.Property === "Car wash";
  } else if (secondary_state === "Building") {
    return element.available_id && element.available_id.Property === "Building";
  } else if (secondary_state === "Agitator") {
    return element.available_id && element.available_id.Property === "Agitator";
  } else if (secondary_state === "residential community") {
    return (
      element.available_id &&
      element.available_id.Property === "residential community"
    );
  } else if (secondary_state === "agricultural land of the register") {
    return (
      element.available_id &&
      element.available_id.Property === "agricultural land of the register"
    );
  } else if (secondary_state === "unregistered agricultural land") {
    return (
      element.available_id &&
      element.available_id.Property === "unregistered agricultural land"
    );
  } else if (secondary_state === "Government agricultural land") {
    return (
      element.available_id &&
      element.available_id.Property === "Government agricultural land"
    );
  } else if (secondary_state === "Land of Istamar") {
    return (
      element.available_id &&
      element.available_id.Property === "Land of Istamar"
    );
  } else if (secondary_state === "Erth Musataha") {
    return (
      element.available_id && element.available_id.Property === "Erth Musataha"
    );
  } else if (secondary_state === "school") {
    return element.available_id && element.available_id.Property === "school";
  } else if (secondary_state === "Building of Istamar") {
    return (
      element.available_id &&
      element.available_id.Property === "Building of Istamar"
    );
  } else if (secondary_state === "Building of Musataha") {
    return (
      element.available_id &&
      element.available_id.Property === "Building of Musataha"
    );
  } else {
    if (
      element.lastPrice &&
      element.lastPrice.toString().startsWith(main_state)
    ) {
      return true;
    } else if (
      element.available_id &&
      element.available_id.NOoFProperty.toString().startsWith(main_state)
    ) {
      return true;
    } else {
      return (
        element.InvoiceNO && element.InvoiceNO.toString().startsWith(main_state)
      );
    }
  }
};

export const FilterComponent_Bills = ({
  main_state,
  secondary_state,
  element,
  name,
  name_2,
}) => {
  if (element.status !== "delete") {
    if (isNaN(main_state)) {
      if (name && name.toLowerCase().startsWith(main_state.toLowerCase())) {
        return name && name.toLowerCase().startsWith(main_state.toLowerCase());
      } else if (
        name_2 &&
        name_2.toLowerCase().startsWith(main_state.toLowerCase())
      ) {
        return (
          name_2 && name_2.toLowerCase().startsWith(main_state.toLowerCase())
        );
      }
    } else if (secondary_state === "Monthly rent invoice") {
      return element.type === "Monthly rent invoice";
    } else if (secondary_state === "Service Bill") {
      return element.type === "Service Bill";
    } else if (secondary_state === "Insurance Bill") {
      return element.type === "Insurance Bill";
    } else if (secondary_state === "Sell") {
      return element.type === "Sell";
    } else if (secondary_state === "Arabun") {
      return element.type === "Arabun";
    } else if (secondary_state === "comision") {
      return element.type === "comision";
    } else if (secondary_state === "investor") {
      return element.type === "investor";
    } else if (secondary_state === "Buy") {
      return element.type === "Buy";
    } else {
      if (element.Amount && element.Amount.toString().startsWith(main_state)) {
        return (
          element.Amount && element.Amount.toString().startsWith(main_state)
        );
      } else {
        return (
          element.invoice_No &&
          element.invoice_No.toString().startsWith(main_state)
        );
      }
    }
  }
};

export const FilterComponent_Properties = ({
  main_state,
  secondary_state,
  third_state,
  element,
  lang,
  type,
}) => {
  const dispatch = useDispatch();
  if (element.status !== "delete" && element.status !== "Rejected") {
    if (main_state !== "") {
      if (isNaN(main_state)) {
        if (element.block && element.block.toString().startsWith(main_state)) {
          return (
            element.block && element.block.toString().startsWith(main_state)
          );
        } else if (
          element.NOoFProperty &&
          element.NOoFProperty.toString().startsWith(main_state)
        ) {
          return (
            element.NOoFProperty &&
            element.NOoFProperty.toString().startsWith(main_state)
          );
        } else if (
          element.Place_ku &&
          element.Place_ku.toLowerCase().startsWith(main_state.toLowerCase())
        ) {
          return lang === "krd"
            ? element.Place_ku &&
                element.Place_ku.toLowerCase().startsWith(
                  main_state.toLowerCase()
                )
            : lang === "en"
            ? element.Place_en &&
              element.Place_en.toLowerCase().startsWith(
                main_state.toLowerCase()
              )
            : element.Place_ar &&
              element.Place_ar.toLowerCase().startsWith(
                main_state.toLowerCase()
              );
        } else if (
          element.Property !== null &&
          element.Property !== undefined &&
          element.Property !== ""
        ) {
          return (
            dispatch(change_Lang(element.Property)) &&
            dispatch(change_Lang(element.Property))
              .toLowerCase()
              .startsWith(main_state.toLowerCase())
          );
        } else if (
          element.block &&
          element.block.toLowerCase().startsWith(main_state.toLowerCase())
        ) {
          return (
            element.block &&
            element.block.toLowerCase().startsWith(main_state.toLowerCase())
          );
        }
      } else if (
        element.Area &&
        element.Area.toString().startsWith(main_state)
      ) {
        return element.Area && element.Area.toString().startsWith(main_state);
      } else if (
        element.flour &&
        element.flour.toString().startsWith(main_state)
      ) {
        return element.flour && element.flour.toString().startsWith(main_state);
      } else if (
        element.price &&
        element.price.toString().startsWith(main_state)
      ) {
        return element.price && element.price.toString().startsWith(main_state);
      } else if (
        element.NOoFProperty &&
        element.NOoFProperty.toString().startsWith(main_state)
      ) {
        return (
          element.NOoFProperty &&
          element.NOoFProperty.toString().startsWith(main_state)
        );
      }
    } else if (secondary_state === true) {
      return element.status !== type && element.status !== "deactive";
    } else if (third_state === true) {
      return element.status === type;
    } else {
      return element;
    }
  }
};
